import RouterSection from '@/components/layout/RouterSection'

export default {
  path: '/information',
  name: 'information-index',
  component: RouterSection,
  redirect: '',
  children: [
    {
      path: 'notice',
      name: 'Notice',
      component: () => import('@/views/information/Notice.vue'),
      props : true
    },
    {
      path: 'notice/:seq',
      name: 'NoticeView',
      component: () => import('@/views/information/NoticeView.vue'),
      props : true
    },
    {
      path: 'faqs',
      name: 'Faqs',
      component: () => import('@/views/information/Faqs.vue')
    },
    {
      path: 'fee',
      name: 'Fee',
      component: () => import('@/views/information/Fee.vue'),
      props : true
    },
    {
      path: 'fee/:seq',
      name: 'FeeView',
      component: () => import('@/views/information/FeeView.vue'),
      props : true
    },
    {
      path: 'qna',
      name: 'Qna',
      component: () => import('@/views/information/Qna.vue'),
      props : true
    },
    {
      path: 'qna/write',
      name: 'QnaAdd',
      component: () => import('@/views/information/QnaAdd.vue')
    },
    {
      path: 'qna/write/:group_nbr',
      name: 'QnaReAdd',
      component: () => import('@/views/information/QnaAdd.vue')
    },
    {
      path: 'qna/:seq',
      name: 'QnaView',
      component: () => import('@/views/information/QnaView.vue'),
      props : true
    },
    {
      path: 'forms',
      name: 'Forms',
      component: () => import('@/views/information/Forms.vue'),
      props : true
    },
    {
      path: 'userguide',
      name: 'Userguide',
      component: () => import('@/views/information/Userguide.vue'),
      props : true
    }

  ]
}
